import { buildThemeContext, ThemeProvider } from '@mgmresorts/wcl-styled';
import React, { useMemo } from 'react';

var ThemeContextProvider = function ThemeContextProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'mgmresorts' : _ref$theme,
      children = _ref.children;
  var themeContext = useMemo(function () {
    return buildThemeContext(theme);
  }, [theme]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children));
};

export { ThemeContextProvider };
